import state from "./moduleInvitationVacancyState";
import mutations from "./moduleInvitationVacancyMutations";
import actions from "./moduleInvitationVacancyActions";
import getters from "./moduleInvitationVacancyGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
